import React, { useState, useEffect, useContext } from 'react';
import { history } from './helpers';
import { HashRouter as Router, Switch } from 'react-router-dom';
import './App.css';
// import { router } from './helpers';
import CustomRoute from './components/CustomRoute';
import { AppContext } from './AppContext';

// Components
import AppSnackbar from './components/AppSnackbar';
import FullScreenLoading from './components/FullScreenLoading';
import EnvironmentIndicator from './components/EnvironmentIndicator';
import { isMobile } from './helpers/os';

const App = props => {
  const [navTree, setNavTree] = useState([]);
  const [isVerifying, setIsVerifying] = useState(true);
  const {
    state: { username, flatRouter },
    dispatch,
  } = useContext(AppContext);

  const renderRouteComp = (route, path) => {
    return <CustomRoute {...route} key={path} path={path} component={route.component} navTree={navTree} />;
  };

  const setupScreenChangeListener = () => {
    /**
     * ! mobile browsers 100vh is actually taller than the visible viewport... so create a CSS variable and set the exact height to go off of on mobile browsers
     * ? https://stackoverflow.com/questions/37112218/css3-100vh-not-constant-in-mobile-browser
     */

    const setCssScreenHeight = () => {
      const root = document.documentElement;

      root.style.setProperty('--screen-height', `${window.innerHeight}px`);
    };

    if (isMobile()) {
      const portrait = window.matchMedia('(orientation: portrait)');

      portrait.addEventListener('change', e => {
        setCssScreenHeight();
      });

      // Detect whether device supports orientationchange event, otherwise fall back to
      // the resize event.
      var supportsOrientationChange = 'onorientationchange' in window,
        orientationEvent = supportsOrientationChange ? 'orientationchange' : 'resize';

      window.addEventListener(
        orientationEvent,
        function() {
          setCssScreenHeight();
        },
        false,
      );
    }

    setCssScreenHeight();
  };

  useEffect(() => {
    // check auth
    const token = localStorage.getItem('token');
    const roles = localStorage.getItem('roles');

    dispatch({
      type: 'UPDATE_ROLES',
      roles: roles || [],
    });

    // redirect to login if a token does not exist
    const privateRoute = !['/login', '/invisioniq'].find(partialRoute => window.location.href.includes(partialRoute));

    if (!token && privateRoute) {
      window.location = '/#/login';
    }
    setIsVerifying(false);

    setupScreenChangeListener();
  }, []);

  return (
    <Router>
      <EnvironmentIndicator />
      
      {/* <div style={{ width: '100%', height: '100%' }}>
        <Switch>{flatRouter.map(route => renderRouteComp(route, route.path))}</Switch>
      </div> */}

      {!isVerifying && (
        <div style={{ width: '100%', height: '100%' }}>
          <Switch>{flatRouter.map(route => renderRouteComp(route, route.path))}</Switch>
        </div>
      )}

      {isVerifying && <FullScreenLoading />}

      <AppSnackbar />
    </Router>
  );
};

export default App;
